var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social"},_vm._l((_vm.data),function(item,index){return _c('a',{key:index,attrs:{"href":item.link,"target":"_blank"}},[_c('v-icon',{attrs:{"name":item.icon}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }